import type { AuthorizedResourceAccessMap } from '@/permissions/adapter';
import {
  type EmployeePortalEffectiveFeatures,
  getEffectiveEmployeePortalAccess,
} from '@/permissions/employeePortalFeatures';

/**
 * @see https://umijs.org/docs/max/access#access
 * */
export default function access(
  initialState:
    | {
        authorizedResourceAccess?: AuthorizedResourceAccessMap;
        currentTenantIsAdmin?: boolean;
        employeePortalFeatures?: EmployeePortalEffectiveFeatures;
      }
    | undefined,
) {
  const {
    authorizedResourceAccess = {},
    currentTenantIsAdmin,
    employeePortalFeatures,
  } = initialState ?? {};

  return {
    ...getEffectiveEmployeePortalAccess(
      authorizedResourceAccess,
      employeePortalFeatures,
    ),
    permission: Boolean(authorizedResourceAccess.permission),
    tenantAdmin: Boolean(currentTenantIsAdmin),
    modelSettings: Boolean(authorizedResourceAccess['model-settings']),
  };
}
